export default __webpack_public_path__ + "static/media/skatebored.aa0f4215.png";